import React from 'react';
import { motion } from 'framer-motion';
export function PricingBlock() {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} className="bg-white border border-slate-200 shadow-xl rounded-2xl p-8 text-center max-w-sm mx-auto w-full relative overflow-hidden" data-id="element-11">
      <div className="absolute top-0 inset-x-0 h-1.5 bg-green-500" data-id="element-12" />
      <div className="space-y-2" data-id="element-13">
        <p className="text-slate-500 font-medium" data-id="element-14">Precio regular</p>
        <p className="text-2xl text-slate-400 line-through font-semibold" data-id="element-15">
          $32.112
        </p>
      </div>
      <div className="mt-6 space-y-1" data-id="element-16">
        <p className="text-sm font-bold text-green-600 uppercase tracking-wider" data-id="element-17">
          Hoy solo
        </p>
        <p className="text-5xl font-extrabold text-green-600" data-id="element-18">$27.100</p>
        <p className="text-sm text-slate-500 font-medium pt-2" data-id="element-19">Pago único</p>
      </div>
    </motion.div>;
}